/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.defs'

export { $nsid }

type JobStatus = {
  $type?: 'app.bsky.video.defs#jobStatus'
  jobId: string
  did: l.DidString

  /**
   * The state of the video processing job. All values not listed as a known value indicate that the job is in process.
   */
  state: 'JOB_STATE_COMPLETED' | 'JOB_STATE_FAILED' | l.UnknownString

  /**
   * Progress within the current processing state.
   */
  progress?: number
  blob?: l.BlobRef
  error?: string
  message?: string
}

export type { JobStatus }

const jobStatus = l.typedObject<JobStatus>(
  $nsid,
  'jobStatus',
  l.object({
    jobId: l.string(),
    did: l.string({ format: 'did' }),
    state: l.string<{
      knownValues: ['JOB_STATE_COMPLETED', 'JOB_STATE_FAILED']
    }>(),
    progress: l.optional(l.integer({ minimum: 0, maximum: 100 })),
    blob: l.optional(l.blob()),
    error: l.optional(l.string()),
    message: l.optional(l.string()),
  }),
)

export { jobStatus }
